module.exports = __webpack_public_path__ + "media/npc_dota_hero_clinkz.881973ba.webm";